import { render, staticRenderFns } from "./tableComponent.vue?vue&type=template&id=2abbae77"
import script from "./tableComponent.vue?vue&type=script&lang=js"
export * from "./tableComponent.vue?vue&type=script&lang=js"
import style0 from "./tableComponent.vue?vue&type=style&index=0&id=2abbae77&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports